export default "__VITE_ASSET__D2qZA1h1__"